module.exports = __webpack_public_path__ + "img/news-small-2.7a2842cf.png";